import { render, staticRenderFns } from "./NewsBanners.vue?vue&type=template&id=3403ac1c&scoped=true"
import script from "./NewsBanners.vue?vue&type=script&lang=js"
export * from "./NewsBanners.vue?vue&type=script&lang=js"
import style0 from "./NewsBanners.vue?vue&type=style&index=0&id=3403ac1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3403ac1c",
  null
  
)

export default component.exports